"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLLING_SUM = void 0;
exports.ROLLING_SUM = {
    alias: 'SOMA_CUMULATIVA',
    description: 'Soma valores da coluna selecionada para todas as colunas enquanto uma coluna especificada se repete',
    arg_names: ['valor_a_somar', 'valor_que_repete', 'coluna_a_ordenar', 'tipo_de_ordem'],
    args_description: ['valor a somar', 'valor que repete', 'coluna a ordenar', 'tipo de ordem'],
    replacements: [
        null,
        null,
        null,
        {
            ASC: 'ASC',
            DESC: 'DESC',
        },
    ],
};
